import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
	updateServerBreadcrumb,
	updateIdServerSelected,
	updateNameServerSelected,
} from "../../../redux/servers/serverSlice";
import { updateIdBankSelected, updateNameBankSelected, updateBankBreadcrumb } from "../../../redux/banks/bankSlice";
// COMPONENTS
import BanksHeader from "./BanksHeader";
import BanksTable from "./BanksTable";
import BanksCreateForm from "./BanksCreateEditForm";
import BanksDrawer from "./BanksDrawer";
import BanksDeleteModal from "./BanksDeleteModal";
import KeysAssignInterface from "../keys/KeysAssignInterfaceBank";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const BanksPage = () => {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		dispatch(updateServerBreadcrumb([]));
		dispatch(updateBankBreadcrumb([]));
		dispatch(updateIdServerSelected(""));
		dispatch(updateIdBankSelected(""));
		dispatch(updateNameBankSelected(""));
		dispatch(updateNameServerSelected(""));
	}, []);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("view-edge-management-banks", permissions) ? (
				<div>
					<div className={`layout__contentPage__${theme}`}>
						<BanksHeader />
						<BanksTable />
						<BanksCreateForm />
						<BanksDrawer />
						<BanksDeleteModal />
						<KeysAssignInterface />
					</div>
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default BanksPage;
